// Wishlist functionality for product buttons
(function() {
  'use strict';

  const STORAGE_KEY = 't4s_wis';
  const MAX_ITEMS = 50;
  
  const Wishlist = {
    items: [],
    
    init: function() {
      this.load();
      this.bindEvents();
      this.updateButtons();
    },
    
    load: function() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          this.items = stored.split(',').map(item => item.replace('id:', ''));
        } else {
          this.items = [];
        }
        console.log('📋 Wishlist items:', this.items);
      } catch (e) {
        console.error('Error loading wishlist:', e);
        this.items = [];
      }
    },
    
    save: function() {
      try {
        if (this.items.length > 0) {
          localStorage.setItem(STORAGE_KEY, this.items.map(id => 'id:' + id).join(','));
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch (e) {
        console.error('Error saving wishlist:', e);
      }
    },
    
    add: function(productId) {
      if (!productId) return;
      
      const id = String(productId);
      
      if (this.items.includes(id)) {
        // Already in wishlist, go to wishlist page
        window.location.href = '/search?view=wishlist';
        return;
      }
      
      this.items.unshift(id);
      if (this.items.length > MAX_ITEMS) {
        this.items.pop();
      }
      
      this.save();
      this.updateButtons();
      
      // Go to wishlist page
      window.location.href = '/search?view=wishlist';
    },
    
    remove: function(productId) {
      const id = String(productId);
      this.items = this.items.filter(item => item !== id);
      this.save();
      this.updateButtons();
    },
    
    updateButtons: function() {
      // Update all wishlist buttons on the page
      document.querySelectorAll('.wishlist-btn, [data-wishlist-btn]').forEach(btn => {
        const id = String(btn.dataset.productId || btn.dataset.id);
        const svg = btn.querySelector('svg');
        
        if (this.items.includes(id)) {
          btn.classList.add('added');
          if (svg) {
            svg.style.fill = 'currentColor';
            // For heart icon specifically
            if (svg.querySelector('path')) {
              svg.querySelector('path').setAttribute('fill', 'currentColor');
            }
          }
        } else {
          btn.classList.remove('added');
          if (svg) {
            svg.style.fill = 'none';
            if (svg.querySelector('path')) {
              svg.querySelector('path').setAttribute('fill', 'none');
            }
          }
        }
      });
      
      // Update wishlist count
      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        el.textContent = this.items.length;
      });
    },
    
    bindEvents: function() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.wishlist-btn, [data-wishlist-btn]');
        if (btn) {
          e.preventDefault();
          const id = btn.dataset.productId || btn.dataset.id;
          if (id) this.add(id);
        }
      });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Wishlist.init());
  } else {
    Wishlist.init();
  }
  
  window.T4SWishlist = Wishlist;
})();